export const CountriesDe = [
  { code: "DE", label: "Deutschland", phone: "49", suggested: true },
  { code: "AT", label: "Österreich", phone: "43" },
  { code: "CH", label: "Schweiz", phone: "41" },
  { code: "FR", label: "Frankreich", phone: "33", suggested: true },
  { code: "NL", label: "Niederlande", phone: "31" },
  { code: "AL", label: "Albanien", phone: "355" },
  { code: "AD", label: "Andorra", phone: "376" },
  { code: "AM", label: "Armenien", phone: "374" },
  { code: "AZ", label: "Aserbaidschan", phone: "994" },
  { code: "BY", label: "Weißrussland", phone: "375" },
  { code: "BE", label: "Belgien", phone: "32" },
  { code: "BA", label: "Bosnien und Herzegowina", phone: "387" },
  { code: "BG", label: "Bulgarien", phone: "359" },
  { code: "HR", label: "Kroatien", phone: "385" },
  { code: "CY", label: "Zypern", phone: "357" },
  { code: "CZ", label: "Tschechische Republik", phone: "420" },
  { code: "DK", label: "Dänemark", phone: "45" },
  { code: "EE", label: "Estland", phone: "372" },
  { code: "FI", label: "Finnland", phone: "358" },
  { code: "GE", label: "Georgien", phone: "995" },
  { code: "GR", label: "Griechenland", phone: "30" },
  { code: "HU", label: "Ungarn", phone: "36" },
  { code: "IS", label: "Island", phone: "354" },
  { code: "IE", label: "Irland", phone: "353" },
  { code: "IT", label: "Italien", phone: "39" },
  { code: "KZ", label: "Kasachstan", phone: "7" },
  { code: "XK", label: "Kosovo", phone: "383" },
  { code: "LV", label: "Lettland", phone: "371" },
  { code: "LI", label: "Liechtenstein", phone: "423" },
  { code: "LT", label: "Litauen", phone: "370" },
  { code: "LU", label: "Luxemburg", phone: "352" },
  { code: "MD", label: "Moldawien Republic of", phone: "373" },
  { code: "MC", label: "Monaco", phone: "377" },
  { code: "ME", label: "Montenegro", phone: "382" },
  { code: "MK", label: "Nord-Mazedonien", phone: "389" },
  { code: "NO", label: "Norwegen", phone: "47" },
  { code: "PL", label: "Polen", phone: "48" },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "RO", label: "Rumänien", phone: "40" },
  { code: "RU", label: "Russische Föderation", phone: "7" },
  { code: "SM", label: "San Marino", phone: "378" },
  { code: "RS", label: "Serbien", phone: "381" },
  { code: "SK", label: "Slowakei", phone: "421" },
  { code: "SI", label: "Slowenien", phone: "386" },
  { code: "ES", label: "Spanien", phone: "34" },
  { code: "SE", label: "Schweden", phone: "46" },
  { code: "TR", label: "Türkei", phone: "90" },
  { code: "UA", label: "Ukraine", phone: "380" },
  { code: "GB", label: "Vereinigtes Königreich", phone: "44" },
  { code: "VA", label: "Vatikanstadt (Heiliger Stuhl)", phone: "379" },
  { code: "AF", label: "Afghanistan", phone: "93" },
  { code: "AG", label: "Antigua und Barbuda", phone: "1-268" },
  { code: "AI", label: "Anguilla", phone: "1-264" },
  { code: "AO", label: "Angola", phone: "244" },
  { code: "AQ", label: "Antarktis", phone: "672" },
  { code: "AR", label: "Argentinien", phone: "54" },
  { code: "AS", label: "Amerikanisch-Samoa", phone: "1-684" },
  { code: "AU", label: "Australien", phone: "61", suggested: true },
  { code: "AW", label: "Aruba", phone: "297" },
  { code: "AX", label: "Alland-Inseln", phone: "358" },
  { code: "BB", label: "Barbados", phone: "1-246" },
  { code: "BD", label: "Bangladesch", phone: "880" },
  { code: "BF", label: "Burkina Faso", phone: "226" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BI", label: "Burundi", phone: "257" },
  { code: "BJ", label: "Benin", phone: "229" },
  { code: "BL", label: "St. Barthelemy", phone: "590" },
  { code: "BM", label: "Bermuda", phone: "1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "673" },
  { code: "BO", label: "Bolivien", phone: "591" },
  { code: "BR", label: "Brasilien", phone: "55" },
  { code: "BS", label: "Bahamas", phone: "1-242" },
  { code: "BT", label: "Bhutan", phone: "975" },
  { code: "BV", label: "Bouvetinsel", phone: "47" },
  { code: "BW", label: "Botswana", phone: "267" },
  { code: "BZ", label: "Belize", phone: "501" },
  { code: "CA", label: "Kanada", phone: "1", suggested: true },
  { code: "CC", label: "Cocos (Keeling) Inseln", phone: "61" },
  { code: "CD", label: "Kongo Republic of the", phone: "242" },
  { code: "CF", label: "Zentralafrikanische Republik", phone: "236" },
  { code: "CG", label: "Kongo Democratic Republic of the", phone: "243" },
  { code: "CI", label: 'Elfenbeinküste"', phone: "225" },
  { code: "CK", label: "Cook-Inseln", phone: "682" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CM", label: "Kamerun", phone: "237" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Kolumbien", phone: "57" },
  { code: "CR", label: "Costa Rica", phone: "506" },
  { code: "CU", label: "Kuba", phone: "53" },
  { code: "CV", label: "Kap Verde", phone: "238" },
  { code: "CW", label: "Curaçao", phone: "599" },
  { code: "CX", label: "Weihnachtsinsel", phone: "61" },
  { code: "DJ", label: "Dschibuti", phone: "253" },
  { code: "DM", label: "Dominica", phone: "1-767" },
  { code: "DO", label: "Dominikanische Republik", phone: "1-809" },
  { code: "DZ", label: "Algerien", phone: "213" },
  { code: "EC", label: "Ecuador", phone: "593" },
  { code: "EG", label: "Ägypten", phone: "20" },
  { code: "EH", label: "Westsahara", phone: "212" },
  { code: "ER", label: "Eritrea", phone: "291" },
  { code: "ET", label: "Äthiopien", phone: "251" },
  { code: "FJ", label: "Fidschi", phone: "679" },
  { code: "FK", label: "Falklandinseln (Malwinen)", phone: "500" },
  { code: "FM", label: "Mikronesien Federated States of", phone: "691" },
  { code: "FO", label: "Färöer Inseln", phone: "298" },
  { code: "GA", label: "Gabun", phone: "241" },
  { code: "GD", label: "Grenada", phone: "1-473" },
  { code: "GF", label: "Französisch-Guayana", phone: "594" },
  { code: "GG", label: "Guernsey", phone: "44" },
  { code: "GH", label: "Ghana", phone: "233" },
  { code: "GI", label: "Gibraltar", phone: "350" },
  { code: "GL", label: "Grönland", phone: "299" },
  { code: "GM", label: "Gambia", phone: "220" },
  { code: "GN", label: "Guinea", phone: "224" },
  { code: "GP", label: "Guadeloupe", phone: "590" },
  { code: "GQ", label: "Äquatorial-Guinea", phone: "240" },
  { code: "GS", label: "Südgeorgien und die Südlichen Sandwichinseln", phone: "500" },
  { code: "GT", label: "Guatemala", phone: "502" },
  { code: "GU", label: "Guam", phone: "1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "245" },
  { code: "GY", label: "Guyana", phone: "592" },
  { code: "HK", label: "Hongkong", phone: "852" },
  { code: "HM", label: "Heard-Insel und McDonald-Inseln", phone: "672" },
  { code: "HN", label: "Honduras", phone: "504" },
  { code: "HT", label: "Haiti", phone: "509" },
  { code: "ID", label: "Indonesien", phone: "62" },
  { code: "IL", label: "Israel", phone: "972" },
  { code: "IM", label: "Isle of Man", phone: "44" },
  { code: "IN", label: "Indien", phone: "91" },
  { code: "IO", label: "Britisches Territorium im Indischen Ozean", phone: "246" },
  { code: "IQ", label: "Irak", phone: "964" },
  { code: "IR", label: "Iran Islamic Republic of", phone: "98" },
  { code: "JE", label: "Jersey", phone: "44" },
  { code: "JM", label: "Jamaika", phone: "1-876" },
  { code: "JO", label: "Jordanien", phone: "962" },
  { code: "JP", label: "Japan", phone: "81", suggested: true },
  { code: "KE", label: "Kenia", phone: "254" },
  { code: "KG", label: "Kirgisistan", phone: "996" },
  { code: "KH", label: "Kambodscha", phone: "855" },
  { code: "KI", label: "Kiribati", phone: "686" },
  { code: "KM", label: "Komoren", phone: "269" },
  { code: "KN", label: "St. Kitts und Nevis", phone: "1-869" },
  { code: "KP", label: "Demokratisches Volk Democratic People's Republic of", phone: "850" },
  { code: "KR", label: "Korea Republic of", phone: "82" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "KY", label: "Cayman-Inseln", phone: "1-345" },
  { code: "LA", label: 's Demokratische Republik"', phone: "856" },
  { code: "LB", label: "Libanon", phone: "961" },
  { code: "LC", label: "St. Lucia", phone: "1-758" },
  { code: "LK", label: "Sri Lanka", phone: "94" },
  { code: "LR", label: "Liberia", phone: "231" },
  { code: "LS", label: "Lesotho", phone: "266" },
  { code: "LY", label: "Libyen", phone: "218" },
  { code: "MA", label: "Marokko", phone: "212" },
  { code: "MF", label: "St. Martin (französischer Teil)", phone: "590" },
  { code: "MG", label: "Madagaskar", phone: "261" },
  { code: "MH", label: "Marshall-Inseln", phone: "692" },
  { code: "ML", label: "Mali", phone: "223" },
  { code: "MM", label: "Myanmar", phone: "95" },
  { code: "MN", label: "Mongolei", phone: "976" },
  { code: "MO", label: "Macao", phone: "853" },
  { code: "MP", label: "Nördliche Marianen", phone: "1-670" },
  { code: "MQ", label: "Martinique", phone: "596" },
  { code: "MR", label: "Mauretanien", phone: "222" },
  { code: "MS", label: "Montserrat", phone: "1-664" },
  { code: "MT", label: "Malta", phone: "356" },
  { code: "MU", label: "Mauritius", phone: "230" },
  { code: "MV", label: "Malediven", phone: "960" },
  { code: "MW", label: "Malawi", phone: "265" },
  { code: "MX", label: "Mexiko", phone: "52" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MZ", label: "Mosambik", phone: "258" },
  { code: "NA", label: "Namibia", phone: "264" },
  { code: "NC", label: "Neukaledonien", phone: "687" },
  { code: "NE", label: "Niger", phone: "227" },
  { code: "NF", label: "Norfolkinsel", phone: "672" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NI", label: "Nicaragua", phone: "505" },
  { code: "NP", label: "Nepal", phone: "977" },
  { code: "NR", label: "Nauru", phone: "674" },
  { code: "NU", label: "Niue", phone: "683" },
  { code: "NZ", label: "Neuseeländisch", phone: "64" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PA", label: "Panama", phone: "507" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PF", label: "Französisch Polynesien", phone: "689" },
  { code: "PG", label: "Papua-Neuguinea", phone: "675" },
  { code: "PH", label: "Philippinen", phone: "63" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PM", label: "St. Pierre und Miquelon", phone: "508" },
  { code: "PN", label: "Pitcairn", phone: "870" },
  { code: "PR", label: "Puerto Rico", phone: "1" },
  { code: "PS", label: "Palästina State of", phone: "970" },
  { code: "PW", label: "Palau", phone: "680" },
  { code: "PY", label: "Paraguay", phone: "595" },
  { code: "QA", label: "Katar", phone: "974" },
  { code: "RE", label: "Reunion", phone: "262" },
  { code: "RW", label: "Ruanda", phone: "250" },
  { code: "SA", label: "Saudi-Arabien", phone: "966" },
  { code: "SB", label: "Salomon-Inseln", phone: "677" },
  { code: "SC", label: "Seychellen", phone: "248" },
  { code: "SD", label: "Sudan", phone: "249" },
  { code: "SG", label: "Singapur", phone: "65" },
  { code: "SH", label: "St. Helena", phone: "290" },
  { code: "SJ", label: "Svalbard und Jan Mayen", phone: "47" },
  { code: "SL", label: "Sierra Leone", phone: "232" },
  { code: "SN", label: "Senegal", phone: "221" },
  { code: "SO", label: "Somalia", phone: "252" },
  { code: "SR", label: "Surinam", phone: "597" },
  { code: "SS", label: "Südsudan", phone: "211" },
  { code: "ST", label: "Sao Tome und Principe", phone: "239" },
  { code: "SV", label: "El Salvador", phone: "503" },
  { code: "SX", label: "Sint Maarten (Niederländischer Teil)", phone: "1-721" },
  { code: "SY", label: "Arabische Republik Syrien", phone: "963" },
  { code: "SZ", label: "Swasiland", phone: "268" },
  { code: "TC", label: "Turks- und Caicosinseln", phone: "1-649" },
  { code: "TD", label: "Tschad", phone: "235" },
  { code: "TF", label: "Französische Süd-Territorien", phone: "262" },
  { code: "TG", label: "Togo", phone: "228" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TJ", label: "Tadschikistan", phone: "992" },
  { code: "TK", label: "Tokelau", phone: "690" },
  { code: "TL", label: "Timor-Leste", phone: "670" },
  { code: "TM", label: "Turkmenistan", phone: "993" },
  { code: "TN", label: "Tunesien", phone: "216" },
  { code: "TO", label: "Tonga", phone: "676" },
  { code: "TT", label: "Trinidad und Tobago", phone: "1-868" },
  { code: "TV", label: "Tuvalu", phone: "688" },
  { code: "TW", label: "Taiwan Province of China", phone: "886" },
  { code: "TZ", label: "Vereinigte Republik Tansania", phone: "255" },
  { code: "UG", label: "Uganda", phone: "256" },
  { code: "AE", label: "Vereinigte Arabische Emirate", phone: "971" },
  { code: "US", label: "Vereinigte Staaten", phone: "1", suggested: true },
  { code: "UY", label: "Uruguay", phone: "598" },
  { code: "UZ", label: "Usbekistan", phone: "998" },
  { code: "VC", label: "St. Vincent und die Grenadinen", phone: "1-784" },
  { code: "VE", label: "Venezuela", phone: "58" },
  { code: "VG", label: "Britische Jungferninseln", phone: "1-284" },
  { code: "VI", label: "US-Jungferninseln", phone: "1-340" },
  { code: "VN", label: "Vietnam", phone: "84" },
  { code: "VU", label: "Vanuatu", phone: "678" },
  { code: "WF", label: "Wallis und Futuna", phone: "681" },
  { code: "WS", label: "Samoa", phone: "685" },
  { code: "YE", label: "Jemen", phone: "967" },
  { code: "YT", label: "Mayotte", phone: "262" },
  { code: "ZA", label: "Süd-Afrika", phone: "27" },
  { code: "ZM", label: "Sambia", phone: "260" },
  { code: "ZW", label: "Simbabwe", phone: "263" },
];
export const CountriesEn = [
  { code: "DE", label: "Germany", phone: "49", suggested: true },
  { code: "AT", label: "Austria", phone: "43" },
  { code: "CH", label: "Switzerland", phone: "41" },
  { code: "FR", label: "France", phone: "33", suggested: true },
  { code: "NL", label: "Netherlands", phone: "31" },
  { code: "AL", label: "Albania", phone: "355" },
  { code: "AD", label: "Andorra", phone: "376" },
  { code: "AM", label: "Armenia", phone: "374" },
  { code: "AZ", label: "Azerbaijan", phone: "994" },
  { code: "BY", label: "Belarus", phone: "375" },
  { code: "BE", label: "Belgium", phone: "32" },
  { code: "BA", label: "Bosnia and Herzegovina", phone: "387" },
  { code: "BG", label: "Bulgaria", phone: "359" },
  { code: "HR", label: "Croatia", phone: "385" },
  { code: "CY", label: "Cyprus", phone: "357" },
  { code: "CZ", label: "Czechia", phone: "420" },
  { code: "DK", label: "Denmark", phone: "45" },
  { code: "EE", label: "Estonia", phone: "372" },
  { code: "FI", label: "Finland", phone: "358" },
  { code: "GE", label: "Georgia", phone: "995" },
  { code: "GR", label: "Greece", phone: "30" },
  { code: "HU", label: "Hungary", phone: "36" },
  { code: "IS", label: "Iceland", phone: "354" },
  { code: "IE", label: "Ireland", phone: "353" },
  { code: "IT", label: "Italy", phone: "39" },
  { code: "KZ", label: "Kazakhstan", phone: "7" },
  { code: "XK", label: "Kosovo", phone: "383" },
  { code: "LV", label: "Latvia", phone: "371" },
  { code: "LI", label: "Liechtenstein", phone: "423" },
  { code: "LT", label: "Lithuania", phone: "370" },
  { code: "LU", label: "Luxembourg", phone: "352" },
  { code: "MD", label: "Moldova, Republic of", phone: "373" },
  { code: "MC", label: "Monaco", phone: "377" },
  { code: "ME", label: "Montenegro", phone: "382" },
  { code: "MK", label: "North Macedonia", phone: "389" },
  { code: "NO", label: "Norway", phone: "47" },
  { code: "PL", label: "Poland", phone: "48" },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "RO", label: "Romania", phone: "40" },
  { code: "RU", label: "Russian Federation", phone: "7" },
  { code: "SM", label: "San Marino", phone: "378" },
  { code: "RS", label: "Serbia", phone: "381" },
  { code: "SK", label: "Slovakia", phone: "421" },
  { code: "SI", label: "Slovenia", phone: "386" },
  { code: "ES", label: "Spain", phone: "34" },
  { code: "SE", label: "Sweden", phone: "46" },
  { code: "TR", label: "Turkey", phone: "90" },
  { code: "UA", label: "Ukraine", phone: "380" },
  { code: "GB", label: "United Kingdom", phone: "44" },
  { code: "VA", label: "Vatican City (Holy See)", phone: "379" },
  { code: "AF", label: "Afghanistan", phone: "93" },
  { code: "AG", label: "Antigua and Barbuda", phone: "1-268" },
  { code: "AI", label: "Anguilla", phone: "1-264" },
  { code: "AO", label: "Angola", phone: "244" },
  { code: "AQ", label: "Antarctica", phone: "672" },
  { code: "AR", label: "Argentina", phone: "54" },
  { code: "AS", label: "American Samoa", phone: "1-684" },
  { code: "AU", label: "Australia", phone: "61", suggested: true },
  { code: "AW", label: "Aruba", phone: "297" },
  { code: "AX", label: "Alland Islands", phone: "358" },
  { code: "BB", label: "Barbados", phone: "1-246" },
  { code: "BD", label: "Bangladesh", phone: "880" },
  { code: "BF", label: "Burkina Faso", phone: "226" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BI", label: "Burundi", phone: "257" },
  { code: "BJ", label: "Benin", phone: "229" },
  { code: "BL", label: "Saint Barthelemy", phone: "590" },
  { code: "BM", label: "Bermuda", phone: "1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "673" },
  { code: "BO", label: "Bolivia", phone: "591" },
  { code: "BR", label: "Brazil", phone: "55" },
  { code: "BS", label: "Bahamas", phone: "1-242" },
  { code: "BT", label: "Bhutan", phone: "975" },
  { code: "BV", label: "Bouvet Island", phone: "47" },
  { code: "BW", label: "Botswana", phone: "267" },
  { code: "BZ", label: "Belize", phone: "501" },
  { code: "CA", label: "Canada", phone: "1", suggested: true },
  { code: "CC", label: "Cocos (Keeling) Islands", phone: "61" },
  { code: "CD", label: "Congo, Republic of the", phone: "242" },
  { code: "CF", label: "Central African Republic", phone: "236" },
  { code: "CG", label: "Congo, Democratic Republic of the", phone: "243" },
  { code: "CI", label: "Cote d'Ivoire", phone: "225" },
  { code: "CK", label: "Cook Islands", phone: "682" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CM", label: "Cameroon", phone: "237" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Colombia", phone: "57" },
  { code: "CR", label: "Costa Rica", phone: "506" },
  { code: "CU", label: "Cuba", phone: "53" },
  { code: "CV", label: "Cape Verde", phone: "238" },
  { code: "CW", label: "Curacao", phone: "599" },
  { code: "CX", label: "Christmas Island", phone: "61" },
  { code: "DJ", label: "Djibouti", phone: "253" },
  { code: "DM", label: "Dominica", phone: "1-767" },
  { code: "DO", label: "Dominican Republic", phone: "1-809" },
  { code: "DZ", label: "Algeria", phone: "213" },
  { code: "EC", label: "Ecuador", phone: "593" },
  { code: "EG", label: "Egypt", phone: "20" },
  { code: "EH", label: "Western Sahara", phone: "212" },
  { code: "ER", label: "Eritrea", phone: "291" },
  { code: "ET", label: "Ethiopia", phone: "251" },
  { code: "FJ", label: "Fiji", phone: "679" },
  { code: "FK", label: "Falkland Islands (Malvinas)", phone: "500" },
  { code: "FM", label: "Micronesia, Federated States of", phone: "691" },
  { code: "FO", label: "Faroe Islands", phone: "298" },
  { code: "GA", label: "Gabon", phone: "241" },
  { code: "GD", label: "Grenada", phone: "1-473" },
  { code: "GF", label: "French Guiana", phone: "594" },
  { code: "GG", label: "Guernsey", phone: "44" },
  { code: "GH", label: "Ghana", phone: "233" },
  { code: "GI", label: "Gibraltar", phone: "350" },
  { code: "GL", label: "Greenland", phone: "299" },
  { code: "GM", label: "Gambia", phone: "220" },
  { code: "GN", label: "Guinea", phone: "224" },
  { code: "GP", label: "Guadeloupe", phone: "590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240" },
  { code: "GS", label: "South Georgia and the South Sandwich Islands", phone: "500" },
  { code: "GT", label: "Guatemala", phone: "502" },
  { code: "GU", label: "Guam", phone: "1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "245" },
  { code: "GY", label: "Guyana", phone: "592" },
  { code: "HK", label: "Hong Kong", phone: "852" },
  { code: "HM", label: "Heard Island and McDonald Islands", phone: "672" },
  { code: "HN", label: "Honduras", phone: "504" },
  { code: "HT", label: "Haiti", phone: "509" },
  { code: "ID", label: "Indonesia", phone: "62" },
  { code: "IL", label: "Israel", phone: "972" },
  { code: "IM", label: "Isle of Man", phone: "44" },
  { code: "IN", label: "India", phone: "91" },
  { code: "IO", label: "British Indian Ocean Territory", phone: "246" },
  { code: "IQ", label: "Iraq", phone: "964" },
  { code: "IR", label: "Iran, Islamic Republic of", phone: "98" },
  { code: "JE", label: "Jersey", phone: "44" },
  { code: "JM", label: "Jamaica", phone: "1-876" },
  { code: "JO", label: "Jordan", phone: "962" },
  { code: "JP", label: "Japan", phone: "81", suggested: true },
  { code: "KE", label: "Kenya", phone: "254" },
  { code: "KG", label: "Kyrgyzstan", phone: "996" },
  { code: "KH", label: "Cambodia", phone: "855" },
  { code: "KI", label: "Kiribati", phone: "686" },
  { code: "KM", label: "Comoros", phone: "269" },
  { code: "KN", label: "Saint Kitts and Nevis", phone: "1-869" },
  { code: "KP", label: "Korea, Democratic People's Republic of", phone: "850" },
  { code: "KR", label: "Korea, Republic of", phone: "82" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "KY", label: "Cayman Islands", phone: "1-345" },
  { code: "LA", label: "Lao People's Democratic Republic", phone: "856" },
  { code: "LB", label: "Lebanon", phone: "961" },
  { code: "LC", label: "Saint Lucia", phone: "1-758" },
  { code: "LK", label: "Sri Lanka", phone: "94" },
  { code: "LR", label: "Liberia", phone: "231" },
  { code: "LS", label: "Lesotho", phone: "266" },
  { code: "LY", label: "Libya", phone: "218" },
  { code: "MA", label: "Morocco", phone: "212" },
  { code: "MF", label: "Saint Martin (French part)", phone: "590" },
  { code: "MG", label: "Madagascar", phone: "261" },
  { code: "MH", label: "Marshall Islands", phone: "692" },
  { code: "ML", label: "Mali", phone: "223" },
  { code: "MM", label: "Myanmar", phone: "95" },
  { code: "MN", label: "Mongolia", phone: "976" },
  { code: "MO", label: "Macao", phone: "853" },
  { code: "MP", label: "Northern Mariana Islands", phone: "1-670" },
  { code: "MQ", label: "Martinique", phone: "596" },
  { code: "MR", label: "Mauritania", phone: "222" },
  { code: "MS", label: "Montserrat", phone: "1-664" },
  { code: "MT", label: "Malta", phone: "356" },
  { code: "MU", label: "Mauritius", phone: "230" },
  { code: "MV", label: "Maldives", phone: "960" },
  { code: "MW", label: "Malawi", phone: "265" },
  { code: "MX", label: "Mexico", phone: "52" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MZ", label: "Mozambique", phone: "258" },
  { code: "NA", label: "Namibia", phone: "264" },
  { code: "NC", label: "New Caledonia", phone: "687" },
  { code: "NE", label: "Niger", phone: "227" },
  { code: "NF", label: "Norfolk Island", phone: "672" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NI", label: "Nicaragua", phone: "505" },
  { code: "NP", label: "Nepal", phone: "977" },
  { code: "NR", label: "Nauru", phone: "674" },
  { code: "NU", label: "Niue", phone: "683" },
  { code: "NZ", label: "New Zealand", phone: "64" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PA", label: "Panama", phone: "507" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PF", label: "French Polynesia", phone: "689" },
  { code: "PG", label: "Papua New Guinea", phone: "675" },
  { code: "PH", label: "Philippines", phone: "63" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PM", label: "Saint Pierre and Miquelon", phone: "508" },
  { code: "PN", label: "Pitcairn", phone: "870" },
  { code: "PR", label: "Puerto Rico", phone: "1" },
  { code: "PS", label: "Palestine, State of", phone: "970" },
  { code: "PW", label: "Palau", phone: "680" },
  { code: "PY", label: "Paraguay", phone: "595" },
  { code: "QA", label: "Qatar", phone: "974" },
  { code: "RE", label: "Reunion", phone: "262" },
  { code: "RW", label: "Rwanda", phone: "250" },
  { code: "SA", label: "Saudi Arabia", phone: "966" },
  { code: "SB", label: "Solomon Islands", phone: "677" },
  { code: "SC", label: "Seychelles", phone: "248" },
  { code: "SD", label: "Sudan", phone: "249" },
  { code: "SG", label: "Singapore", phone: "65" },
  { code: "SH", label: "Saint Helena", phone: "290" },
  { code: "SJ", label: "Svalbard and Jan Mayen", phone: "47" },
  { code: "SL", label: "Sierra Leone", phone: "232" },
  { code: "SN", label: "Senegal", phone: "221" },
  { code: "SO", label: "Somalia", phone: "252" },
  { code: "SR", label: "Suriname", phone: "597" },
  { code: "SS", label: "South Sudan", phone: "211" },
  { code: "ST", label: "Sao Tome and Principe", phone: "239" },
  { code: "SV", label: "El Salvador", phone: "503" },
  { code: "SX", label: "Sint Maarten (Dutch part)", phone: "1-721" },
  { code: "SY", label: "Syrian Arab Republic", phone: "963" },
  { code: "SZ", label: "Swaziland", phone: "268" },
  { code: "TC", label: "Turks and Caicos Islands", phone: "1-649" },
  { code: "TD", label: "Chad", phone: "235" },
  { code: "TF", label: "French Southern Territories", phone: "262" },
  { code: "TG", label: "Togo", phone: "228" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TJ", label: "Tajikistan", phone: "992" },
  { code: "TK", label: "Tokelau", phone: "690" },
  { code: "TL", label: "Timor-Leste", phone: "670" },
  { code: "TM", label: "Turkmenistan", phone: "993" },
  { code: "TN", label: "Tunisia", phone: "216" },
  { code: "TO", label: "Tonga", phone: "676" },
  { code: "TT", label: "Trinidad and Tobago", phone: "1-868" },
  { code: "TV", label: "Tuvalu", phone: "688" },
  { code: "TW", label: "Taiwan, Province of China", phone: "886" },
  { code: "TZ", label: "United Republic of Tanzania", phone: "255" },
  { code: "UG", label: "Uganda", phone: "256" },
  { code: "AE", label: "United Arab Emirates", phone: "971" },
  { code: "US", label: "United States", phone: "1", suggested: true },
  { code: "UY", label: "Uruguay", phone: "598" },
  { code: "UZ", label: "Uzbekistan", phone: "998" },
  { code: "VC", label: "Saint Vincent and the Grenadines", phone: "1-784" },
  { code: "VE", label: "Venezuela", phone: "58" },
  { code: "VG", label: "British Virgin Islands", phone: "1-284" },
  { code: "VI", label: "US Virgin Islands", phone: "1-340" },
  { code: "VN", label: "Vietnam", phone: "84" },
  { code: "VU", label: "Vanuatu", phone: "678" },
  { code: "WF", label: "Wallis and Futuna", phone: "681" },
  { code: "WS", label: "Samoa", phone: "685" },
  { code: "YE", label: "Yemen", phone: "967" },
  { code: "YT", label: "Mayotte", phone: "262" },
  { code: "ZA", label: "South Africa", phone: "27" },
  { code: "ZM", label: "Zambia", phone: "260" },
  { code: "ZW", label: "Zimbabwe", phone: "263" },
];
